import React from 'react';
import { Switch, SwitchProps } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { defaultTheme } from '../../lib/themes';

interface IArborSwitchProps extends SwitchProps {
  ['data-qa-id']?: string;
}

export const ArborSwitch = withStyles({
  switchBase: {
    'color': defaultTheme.palette.primary.patina,
    '&.Mui-checked': {
      color: defaultTheme.palette.primary.patina,
    },
    '&.Mui-checked + $track': {
      backgroundColor: defaultTheme.palette.primary.patina,
    },
    '&': {
      color: defaultTheme.palette.primary.grey2,
    },
  },
  checked: {},
  track: {},
})((props: IArborSwitchProps) => <Switch {...props} />);

export const CustomizedSwitch = withStyles({
  root: {
    width: 72, // increase width
    height: 35, // increase height
    padding: 0,
  },
  switchBase: {
    'padding': 2,
    'color': defaultTheme.palette.primary.white,
    '&.Mui-checked': {
      color: defaultTheme.palette.primary.white,
      transform: 'translateX(37px)', // adjust movement for new size
    },
    '&.Mui-checked + $track': {
      backgroundColor: defaultTheme.palette.primary.deepBlue,
      opacity: '1 !important',
    },
    '&': {
      color: defaultTheme.palette.primary.grey2,
    },
  },
  checked: {},
  track: {
    borderRadius: 35 / 2,
    backgroundColor: defaultTheme.palette.primary.grey23,
    opacity: 1,
  },
  thumb: {
    width: 30, // increase thumb size
    height: 30,
  },
})((props: IArborSwitchProps) => <Switch {...props} />);
